export enum ScreenStyleConfigKey {
  DEFAULT = 'organicScreen',
  NON_ORGANIC_DEFAULT = 'nonOrganicScreen',
}
